import { PPDTracker, TRACK_EVENT_TYPE, IMP_TYPE } from '@widget/tool';
import Cookies from 'js-cookie';
const openId = Cookies.get('openid');

const exposureImpPage = {
    // 需要设置曝光的页面的埋点信息，不在这个配置里面的点是不会进入滚动曝光的逻辑的，即是否曝光不会被客户端控制
    // tgt_name的匹配规则，每一个应该被滚动曝光的点，都需要在div上拥有name属性==tgt_nameRule匹配后的结果
    'super-TestPage-super_scrollImp': {
        tgt_event_id: 'super_scrollImp',
        nodeRule: /(.*)/,
        paramName: 'imphooksName',
        needCombine: false // 需要合并吗，默认需要合并
    }
};
// 埋点元素class和他一行能容纳的个数
const rowAmountMap = {
    scrollImp: 99 // banner
};

function getMergeOption(impObj) {
    let pageKey = impObj.page + '-' + impObj.tgt_event_id;
    let mergeOption = exposureImpPage[pageKey];
    mergeOption && (mergeOption.rowAmountMap = rowAmountMap);
    return mergeOption || null;
}

// 滚动曝光会记录 imphook-name 匹配 tgt_nameRule 的imp事件
let ppdTracker = new PPDTracker({
    EXPOSED_PERCENT: 0.5,
    isHalfAppPage: false,
    STAY_TIME: 2000
});
/**
 * 判断值是否为空
 * @param {要判断的值} val
 * @param {0是否为空}} isZeroNull
 * @returns Boolean
 */
function isEmpty(val, isZeroNull = false) {
    return val === '' || val === null || val === undefined || (isZeroNull && val === 0);
}

const POINT = function(key, params) {
    try {
        params['url'] = isEmpty(params['url']) ? window.location.href : params['url'];
        params['target_url'] = isEmpty(params['target_url'])
            ? window.location.href
            : params['target_url'];
        let eventParams = {};
        if (key === TRACK_EVENT_TYPE.ELEMENT_IMP) {
            let mergeOption = getMergeOption(params);
            if (mergeOption) {
                eventParams.impType = IMP_TYPE.SCROLL_IMP;
                eventParams.mergeOption = mergeOption;
            }
        }
        Object.assign(params, { openId });
        ppdTracker.track(key, params, eventParams);
    } catch (e) {
        console.error(e);
    }
};
export default POINT;
